import { buttonWithoutHoverStyles } from '@trustedshops/tps-seo-shared-frontend-react-components';
import { LinkAsButtonProps } from 'models/LinkProps';
import { css } from 'styled-components';

/* Some buttons (like those in the pagination) can have Sticky Hover States on mobile devices,
 * see https://css-tricks.com/solving-sticky-hover-states-with-media-hover-hover.
 * Therefore, we overwrite the default hover CSS rules. */
export const noStickyHover = css<LinkAsButtonProps>`
  @media (hover: none) {
    &:hover {
      ${(props) => buttonWithoutHoverStyles[props.context]}
    }
  }
`;
